import { defineStore } from 'pinia'
import { IGiveawayActivityItem, IVoucherList } from '@/@types/types'

export const useVerifyCodeStore = defineStore('__mall_verify_code__', {
  state: () => ({
    count: 60,
    timer: null as unknown as number | null,
  }),
})
